// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getTimelineInterventions } from "../../api";
import { PatientInterventionType } from "../../types";

export const useInterventionsData = (
  clinicId: string | undefined,
  patientId: string
) => {
  const { getToken } = useTokenAccess();

  return useQuery<PatientInterventionType>({
    queryKey: ["timeline-interventions", clinicId, patientId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getTimelineInterventions(
        token,
        clinicId,
        patientId,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
